import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont } from '../../theme';

export const useAirlineLogosStyles = createStyles(({ token }) => ({
  missingAirlineLogo: {
    width: 30,
    height: 30,
    border: `1px solid ${ThemeColors.COLOR_GREY7_8}`,
    backgroundColor: ThemeColors.COLOR_GREY9_9,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '.fas': {
      color: ThemeColors.COLOR_BLUE3,
      fontSize: 22,
    },
  },
  airlineLogoUnknown: {
    height: '16px',
    width: '16px',
    fontSize: token.fontSizeLG,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '50%',
    background: `linear-gradient(180deg, ${token.colorWhite}, ${ThemeColors.COLOR_BLUE2} 33%)`,
    border: `1px solid ${ThemeColors.COLOR_BLUE2}`,
    color: token.colorWhite,
    fontWeight: 700,
    fontFamily: ThemeFont.FONT_CONDENSED,
  },
}));
